import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { expensesType_response } from "../../services/api/api";


type select = {
    value: string | number,
    label: string
}

type ClientSelectProps = {
    value: string | number,
    label: string,
    phoneNumber: string,
    address: string
}

interface expensesType  extends select , expensesType_response {}

// Predefined state
export interface predefinedState {
    materials: {
        list: select[],
   
        isLoaded: boolean
    },
    services: {
        list: select[],
     
        isLoaded: boolean
    },
    roles: {
        list: select[],
        isLoaded: boolean
    },
    employees: {
        list: select[],
        isLoaded: boolean
    },
    products: {
        list: select[],
        isLoaded: boolean
    },
    clients: {
        list: ClientSelectProps[],
        isLoaded: boolean
    },
    suppliers: {
        list: select[],
        isLoaded: boolean
    },
    orders: {
        list: select[],
        isLoaded: boolean
    },
    expenses_type : {
        list:expensesType[],
        isLoaded:boolean
    }
}

const initialPredefinedState: predefinedState = {
    materials: {
        list: [],
    
        isLoaded: false
    },
    services: {
        list: [],
       
        isLoaded: false
    },
    roles: {
        list: [],
        isLoaded: false
    },
    employees: {
        list: [],
        isLoaded: false
    },
    products: {
        list: [],
        isLoaded: false
    },
    clients: {
        list: [],
        isLoaded: false
    },
    suppliers: {
        list: [],
        isLoaded: false
    },
    orders: {
        list: [],
        isLoaded: false
    },
    expenses_type: {
        list:[],
        isLoaded:false
    }
}

// Predefined slice
export const predefinedMenusSlice = createSlice({
    name: 'predefined',
    initialState: initialPredefinedState,
    reducers: {
       
       
        setRoles: ( state, {payload}: PayloadAction<{ list: select[] }> ) => {
            state.roles = {
                list: payload.list,
                isLoaded: true
            }
        },
        setEmployees: ( state, {payload}: PayloadAction<{ list: select[] }> ) => {
            state.employees = {
                list: payload.list,
                isLoaded: true
            }
        },
        setProducts: ( state, {payload}: PayloadAction<{ list: select[] }> ) => {
            state.products = {
                list: payload.list,
                isLoaded: true
            }
        },
        setClients: ( state, {payload}: PayloadAction<{ list: ClientSelectProps[] }> ) => {
            state.clients = {
                list: payload.list,
                isLoaded: true
            }
        },
        setSuppliers: ( state, {payload}: PayloadAction<{ list: select[] }> ) => {
            state.suppliers = {
                list: payload.list,
                isLoaded: true
            }
        },
        setOrders: ( state, {payload}: PayloadAction<{ list: select[] }> ) => {
            state.orders = {
                list: payload.list,
                isLoaded: true
            }
        },
        setExpensesType : (state,{payload}:PayloadAction<{list:expensesType[]}>)=>{
            state.expenses_type={
                list:payload.list,
                isLoaded:true
            }
        }
    }
})